/**
 * Asynchronously loads the component for WorkflowDetailsPage
 */

import { lazyLoad } from 'utils/loadable';

export const WorkflowDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.WorkflowDetailsPage,
);
